import React, { useState } from "react";
import dayjs from "dayjs";
import { Formik } from "formik";

import Alert from "@mui/material/Alert";

import CalendarField from "components/calendarField";
import Input from "components/bannerInput";
import Button from "components/button";
import PhoneNumber from "components/phoneInput";
import { useTranslation } from "i18n";

const ProfileTab = ({
  getMemberInfo,
  validationSchema,
  handelSubmit,
  error,
  success,
  handleShowPassword,
  loading,
}) => {
  const [code, setCode] = useState();
  const { t } = useTranslation();

  return (
    <Formik
      initialValues={{
        firstName: getMemberInfo?.firstName,
        lastName: getMemberInfo?.lastName,

        dateOfBirthDay: getMemberInfo?.dateOfBirth
          ? dayjs.utc(getMemberInfo?.dateOfBirth).format("DD")
          : "",
        dateOfBirthMonth: getMemberInfo?.dateOfBirth
          ? dayjs(getMemberInfo?.dateOfBirth).format("MM")
          : "",
        dateOfBirthYear: getMemberInfo?.dateOfBirth
          ? dayjs(getMemberInfo?.dateOfBirth).format("YYYY")
          : "",
        phoneNumber: getMemberInfo?.phoneNumber,
        email: getMemberInfo?.email,
        passportNumber: getMemberInfo?.passportNumber,
      }}
      validationSchema={validationSchema}
      onSubmit={handelSubmit}
      enableReinitialize={true}
      validateOnBlur={true}
    >
      {({
        handleChange,
        handleSubmit,
        errors,
        setFieldTouched,
        touched,
        values,
      }) => (
        <div className="account-profile">
          <div className="account-profile__intro">
            <h2>{t("account.tabs.myAccount")}</h2>
            <p>{t("account.profileHint")}</p>
          </div>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          {success && (
            <Alert severity="success" sx={{ mb: 2 }}>
              {success}
            </Alert>
          )}

          <div className="account-profile__block">
            <h3>{t("account.personalDetails")}</h3>
            <div className="form">
              <Input
                onChange={handleChange(`firstName`)}
                error={touched.firstName && errors.firstName}
                onBlur={() => setFieldTouched("firstName")}
                name={"firstName"}
                mandatory={true}
                type="firstName"
                label={t("account.firstName")}
                value={values?.firstName}
              />
              <Input
                onChange={handleChange(`lastName`)}
                error={touched.lastName && errors.lastName}
                onBlur={() => setFieldTouched("lastName")}
                name={"lastName"}
                mandatory={true}
                label={t("account.lastName")}
                value={values?.lastName}
              />
              <CalendarField
                valueDay={values["dateOfBirthDay"]}
                valueMonth={values["dateOfBirthMonth"]}
                valueYear={values["dateOfBirthYear"]}
                error1={touched.dateOfBirthDay && errors.dateOfBirthDay}
                error2={errors.dateOfBirthMonth && touched.dateOfBirthMonth}
                error3={errors.dateOfBirthYear && touched.dateOfBirthYear}
                nameDay={`dateOfBirthDay`}
                nameMonth={`dateOfBirthMonth`}
                nameYear={`dateOfBirthYear`}
                onChangeDay={handleChange(`dateOfBirthDay`)}
                onChangeMonth={handleChange("dateOfBirthMonth")}
                onChangeYear={handleChange("dateOfBirthYear")}
                onBlurDay={() => setFieldTouched("dateOfBirthYear")}
                onBlurMonth={() => setFieldTouched("onBlurMonth")}
                onBlurYear={() => setFieldTouched("onBlurYear")}
                label={t("account.dateOfBirth")}
              />
              <Input
                onChange={handleChange(`passportNumber`)}
                error={touched.passportNumber && errors.passportNumber}
                onBlur={() => setFieldTouched("passportNumber")}
                name={"passportNumber"}
                value={values?.passportNumber}
                label={t("account.passportNumber")}
              />
            </div>
          </div>

          <div className="account-profile__block">
            <h3>{t("account.contactDetails")}</h3>
            <div className="form">
              <Input
                onChange={handleChange(`email`)}
                error={touched.email && errors.email}
                onBlur={() => setFieldTouched("email")}
                name={"email"}
                mandatory={true}
                type="email"
                label={t("account.email")}
                value={values?.email}
                disabled="true"
              />
              <PhoneNumber
                onChange={handleChange(`phoneNumber`)}
                error={touched.phoneNumber && errors.phoneNumber}
                onBlur={() => setFieldTouched("phoneNumber")}
                name={"phoneNumber"}
                label={t("account.phoneNumber")}
                value={values?.phoneNumber}
                setCode={setCode}
              />
            </div>
          </div>

          <div className="account-profile__actions">
            <button
              type="button"
              className="account-profile__link"
              onClick={handleShowPassword}
            >
              {t("account.changePasswordQuestion")}
            </button>
            <Button
              type="submit"
              onClick={handleSubmit}
              className="bigBtn primary-color"
              loading={loading}
            >
              {t("account.saveChanges")}
            </Button>
          </div>
        </div>
      )}
    </Formik>
  );
};

export default ProfileTab;
